import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { experimentManagementApi } from '@/entities/experiment/api/experimentManagementApi';
import type { CreateExperimentRequest } from '@/entities/experiment/domain/experimentManagementTypes';
import { PROJECTS_EXPERIMENTS_QUERY_KEY } from '@/entities/experiment/model/useProjectsExperiments';

import { EXPERIMENT_MANAGEMENT_QUERY_KEY } from './useExperimentManagementList';

export const useCreateExperimentManagement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateExperimentRequest) => experimentManagementApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EXPERIMENT_MANAGEMENT_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROJECTS_EXPERIMENTS_QUERY_KEY] });
      message.success('실험이 생성되었습니다');
    },
  });
};
